export const busPhotos = Array.from({ length: 20 }, (_, i) => ({
  id: i + 1,
  src: `/assets/bus/bus (${i + 1}).png`,
  alt: `Morocco Loves You VIP Bus ${i + 1}`
}));
